import { render, staticRenderFns } from "./department.vue?vue&type=template&id=ac0b3e40&scoped=true"
import script from "./department.vue?vue&type=script&lang=js"
export * from "./department.vue?vue&type=script&lang=js"
import style0 from "./department.vue?vue&type=style&index=0&id=ac0b3e40&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0b3e40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac0b3e40')) {
      api.createRecord('ac0b3e40', component.options)
    } else {
      api.reload('ac0b3e40', component.options)
    }
    module.hot.accept("./department.vue?vue&type=template&id=ac0b3e40&scoped=true", function () {
      api.rerender('ac0b3e40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/basic/configure/department.vue"
export default component.exports